"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineCSSVars = exports.designToken = void 0;
function transformValueToCSSVar(value) {
    return `var(--${value.id}, ${typeof value.value === 'object' ? transformValueToCSSVar(value.value) : value.value})`;
}
function designToken(value) {
    const id = `dt-${Math.random().toString(16).slice(2)}`;
    const lowerCaseId = id.replace(/([A-Z])/g, '-$1').toLowerCase();
    const specValue = {
        id: lowerCaseId,
        value
    };
    let cssVar = '';
    return Object.assign(Object.assign({}, specValue), { var() {
            if (!cssVar) {
                cssVar = transformValueToCSSVar(specValue);
            }
            return cssVar;
        },
        getStringValue(element) {
            return getComputedStyle(element || document.documentElement).getPropertyValue(`--${lowerCaseId}`);
        },
        getIntValue(element) {
            return parseInt(getComputedStyle(element || document.documentElement).getPropertyValue(`--${lowerCaseId}`), 10);
        } });
}
exports.designToken = designToken;
function defineCSSVars(spec, overwriteSpec) {
    const items = [];
    const nextSpec = Object.assign({}, spec);
    const parse = (value) => {
        if (typeof value.value === 'object') {
            parse(value.value);
        }
        items.push(`--${value.id}: ${typeof value.value !== 'object' ? value.value : `var(--${value.value.id})`};`);
    };
    if (overwriteSpec) {
        Object.keys(spec).forEach((key) => {
            if (overwriteSpec[key]) {
                nextSpec[key] = Object.assign(Object.assign({}, overwriteSpec[key]), { id: spec[key].id });
            }
        });
    }
    Object.values(nextSpec).forEach(parse);
    return items.join('\n');
}
exports.defineCSSVars = defineCSSVars;
//# sourceMappingURL=utils.js.map